"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseWrapper = exports.Wrapper = exports.ContentWrapper = exports.BackgroundArea = exports.Modal = exports.Title = exports.ModalHeaderContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../../theme/colors");
exports.ModalHeaderContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
exports.Title = styled_components_1.default.h2 `
  font-size: 40px;
  margin: 0;
  @media screen and (max-width: 688px) {
    font-size: 20px;
    padding-left: 16px;
  }
  font-weight: bold;
`;
exports.Modal = styled_components_1.default.div `
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: ${colors_1.WHITE};
  border: 1px solid black;
  padding: 32px;
  z-index: 10;
`;
exports.BackgroundArea = styled_components_1.default.div `
  height: 100vh;
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${colors_1.BLACK};
  opacity: ${({ $opacity }) => ($opacity ? $opacity : 0.7)};
  z-index: 10;
`;
exports.ContentWrapper = styled_components_1.default.div `
  display: grid;
  grid-auto-flow: column;
  column-gap: 16px;
  @media screen and (max-width: 688px) {
    grid-auto-flow: row;
    row-gap: 16px;
  }
`;
exports.Wrapper = styled_components_1.default.div `
  display: ${({ $open }) => ($open ? "block" : "none")};
`;
exports.CloseWrapper = styled_components_1.default.div `
  display: flex;
  cursor: pointer;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  text-transform: uppercase;

  & span {
    position: relative;
    top: 3px;
  }
`;
//# sourceMappingURL=Dialog.styles.js.map